import {SortSettings} from '../interfaces';

export function getDefaultSortSettings(): SortSettings {
    return {
        sortArticles: false
    };
}
